module.exports = __webpack_public_path__ + "static/harvest-3ac338bcd9949a5ca19271f5f3879fb7.png";